// import { appointmentCategoriesData } from "./mocks/appointments";
import { axiosCall } from './utils/axios';
import { getMeta }   from './helpers/main';

const locale = getMeta('locale');
const selectAppointmentName = document.getElementById("select-appointment-name");
const selectAppointmentCategories = document.getElementById("select-appointment-categories");
const selectAppointmentCategoriesSkills = document.getElementById("select-appointment-categories-skills");
const appointmentAccIdAttribute = document.getElementById("appointment-ac-id");
const appointmentLsAttribute = document.getElementById("appointment-ls");
const submitBtn = document.getElementById("submit-btn");
const handler = document.getElementById("categories_handler");
const borderSelector = document.getElementById("border-selector");
const categoryLinkClient = document.getElementById("category_link_client");
const categoryLinkProf = document.getElementById("category_link_prof");
const categoryLinkEnterprise = document.getElementById("category_link_entreprise");

let arrCategories = [];
let arrSkills = [];

function sortArray(array) {
    array.sort((a, b) => a.name.localeCompare(b.name));
    array.forEach(a => {
        if (a.appointment_categories && a.appointment_categories.length > 0) {
            sortArray(a.appointment_categories).sort((a, b) => a.custom_order - b.custom_order);
        }
        if (a.location_skills && a.location_skills.length > 0) {
            sortArray(a.location_skills)
        }
    })
    return array;
}

document.addEventListener('DOMContentLoaded', async function(){
    submitBtn.setAttribute('disabled', true);

    const isProd = window.location.hostname === 'client.calizy.com';

    if (isProd) {
        if (categoryLinkClient) {
            categoryLinkClient.href = 'https://auth.ag2rlamondiale.fr/login?service=https%3A%2F%2Fauth.ag2rlamondiale.fr%2Foauth2.0%2FcallbackAuthorize%3Fclient_id%3Da0533_cug%26scope%3Dopenid%2Balm%26redirect_uri%3Dhttps%253A%252F%252Fespace-client.ag2rlamondiale.fr%252Fcug%252Flogin%252Foauth2%252Fcode%252Fcas%26response_type%3Dcode%26state%3Dp_QOjIrrMWFJX3WG4avqQ0o6HGJfU_C57Op795obybg%253D%26nonce%3DkUBW8rD24aTLa0kTMn_5IBt29QtDb_J2EFf3BFCArDk%26client_name%3DCasOAuthClient';
        }
        if (categoryLinkProf) {
            categoryLinkProf.href = 'https://www.ag2rlamondiale.fr/contactez-nous';
        }
        if (categoryLinkEnterprise) {
            categoryLinkEnterprise.href = 'https://www.ag2rlamondiale.fr/contactez-nous';
        }
    }

    if (selectAppointmentName) {
        borderSelector.classList.add('border-animation');
        selectAppointmentName.setAttribute('disabled', true);

        const appointmentCategoriesData = await axiosCall({
            url: `/api/appointment_categories?account_id=${handler.dataset.accountId}&locale=${locale}`,
        });

        const filteredAppointmentCategoriesData = sortArray(appointmentCategoriesData.filter(category => !!category.name));

        borderSelector.classList.remove('border-animation');
        selectAppointmentName.removeAttribute('disabled');

        selectAppointmentName.selectedIndex = -1;
        selectAppointmentCategories.setAttribute("disabled", true);
        selectAppointmentCategoriesSkills.setAttribute("disabled", true);

        if (filteredAppointmentCategoriesData.length) {
            const parser = new DOMParser();
            filteredAppointmentCategoriesData.forEach(category => {
                const doc = parser.parseFromString(category.name, 'text/html');
                category.name = doc.body.textContent;
            })
        }

        const defaultOption = new Option(locale === 'en' ? 'Select a value' : 'Sélectionner une valeur',"");
        if (filteredAppointmentCategoriesData.length === 1) {
            selectAppointmentName.add(new Option(filteredAppointmentCategoriesData[0].name));
            selectAppointmentName.setAttribute('disabled', true);

            setTimeout(() => {
                const event = new Event("change", { bubbles: true });
                selectAppointmentName.dispatchEvent(event);
            }, 100);
        } else {
            defaultOption.setAttribute('hidden', true);
            selectAppointmentName.add(defaultOption);
            for (let i = 0; i < filteredAppointmentCategoriesData.length; i++) {
                selectAppointmentName.add(new Option(filteredAppointmentCategoriesData[i].name));
            }
        }

        selectAppointmentName.addEventListener("change", function(e) {
            if (selectAppointmentName.value) {
                selectAppointmentCategories.removeAttribute("disabled");
                selectAppointmentCategoriesSkills.setAttribute("disabled", true);
                submitBtn.setAttribute('disabled', true);

                filteredAppointmentCategoriesData.map(item => {
                    if (item.name.replace(/\s+/g,' ').trim() === selectAppointmentName.value) {
                        selectAppointmentCategories.innerHTML = "";
                        selectAppointmentCategoriesSkills.innerHTML = "";

                        selectAppointmentCategories.add(defaultOption);
                        for (let i = 0; i < item.appointment_categories.length; i++) {
                            selectAppointmentCategories.add(new Option(item.appointment_categories[i].name));
                        }

                        arrCategories = item.appointment_categories;
                    }
                })

                if (arrCategories.length === 1) {
                    if (arrCategories[0].url) {
                        window.open(arrCategories[0].url, '_blank');
                    } else {
                        selectAppointmentCategories.value = arrCategories[0].name;
                        selectAppointmentCategories.setAttribute('disabled', true);

                        setTimeout(() => {
                            const event = new Event("change", { bubbles: true });
                            selectAppointmentCategories.dispatchEvent(event);
                        }, 100);
                    }
                }
            }
        });

        selectAppointmentCategories.addEventListener("change", function(e) {
            if (selectAppointmentCategories.value) {
                selectAppointmentCategoriesSkills.removeAttribute("disabled");
                submitBtn.setAttribute('disabled', true);

                arrCategories.map(item => {
                    if (item.name.replace(/\s+/g,' ').trim() === selectAppointmentCategories.value) {
                        selectAppointmentCategoriesSkills.innerHTML = "";
                        appointmentAccIdAttribute.value = item.id;

                        const defaultOption = new Option(locale === 'en' ? 'Select a value' : 'Sélectionner une valeur',"");
                        defaultOption.setAttribute('hidden', true);

                        selectAppointmentCategoriesSkills.add(defaultOption);

                        for (let i = 0; i < item.location_skills.length; i++) {
                            selectAppointmentCategoriesSkills.add(new Option(item.location_skills[i].name));
                        }

                        arrSkills = item.location_skills;
                    }
                })

                if (arrSkills.length === 1) {
                    selectAppointmentCategoriesSkills.value = arrSkills[0].name;

                    setTimeout(() => {
                        const event = new Event("change", { bubbles: true });
                        selectAppointmentCategoriesSkills.dispatchEvent(event);
                    }, 100);
                    selectAppointmentCategoriesSkills.setAttribute('disabled', true);
                }
            }
        });

        selectAppointmentCategoriesSkills.addEventListener("change", function(e) {
            if (selectAppointmentCategoriesSkills.value) {
                if (arrSkills.length !== 1) {
                    selectAppointmentCategoriesSkills.removeAttribute("disabled");
                }

                arrSkills.map(item => {
                    if (item.name.replace(/\s+/g,' ').trim() === selectAppointmentCategoriesSkills.value) {
                        submitBtn.removeAttribute('disabled');
                        appointmentLsAttribute.value = item.id;
                    }
                })
            }
        });
    }
});
